import { MatIcon, MatIconModule } from '@angular/material/icon';
import { Support, TranslateHelper } from '@app/_helpers';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { IconComponent } from '@app/shared/components/icon/icon.component';
import * as _ from 'lodash';
import { CollapseItemDirective, CollapseContentDirective } from '../../../shared/directives/collapse.directive';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { NgIf, NgFor, NgClass } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-select-button',
    templateUrl: './select-button.component.html',
    styleUrls: ['./select-button.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [
        NgIf,
        CdkOverlayOrigin,
        MatIconModule,
        CdkConnectedOverlay,
        NgFor,
        CollapseItemDirective,
        CollapseContentDirective,
        NgClass
    ],
})
export class SelectButtonComponent implements OnInit {

    constructor(public translateHelper: TranslateHelper, public translate: TranslateService,
        private cdr: ChangeDetectorRef,

    ) { }

    FilterCtrl: UntypedFormControl = new UntypedFormControl();
    filteredList: ReplaySubject<any> = new ReplaySubject<any>(1);

    @Input() label;
    @Input() customLabel;
    @Input() appearance: 'legacy' | 'standard' | 'fill' | 'outline' | 'filter' = 'outline';
    @Input() floatLabel: 'always' | 'auto' = 'auto';
    @Input() placeholder = '';
    @Input() selectList;
    @Input() control: UntypedFormControl;
    @Input() combineLabel;
    @Input() combineSelectList;
    @Input() combineControl: UntypedFormControl;
    @Input() multiple;
    @Output() selectChange: EventEmitter<any> = new EventEmitter();

    @ViewChild("btnRef", { static: false }) btn;
    @ViewChild("btnIconRef", { static: false }) btnIcon;
    @ViewChild("btnLabelRef", { static: false }) btnLabel;

    selected = [];
    selectedLabel = '';

    /*  ngOnDestroy(): void {
         this.control.reset();
         this.combineControl.reset();
     } */

    ngOnInit(): void {

        this.selected = [];
        this.selectedLabel = '';
        this.multiple = Support.numberToBoolean(this.multiple);


        if (this.multiple && this.control.value?.length) {
            _.forEach(this.selectList, (selectItem) => {
                if (selectItem.count !== 0 &&this.control.value.includes(selectItem._id)) {
                    selectItem.selected = true
                    this.selected.push(selectItem.name[this.translate.currentLang]);
                };
            })
        } else if (this.control.value) {
            _.forEach(this.selectList, (selectItem) => {
                if (selectItem.count !== 0 && this.control.value.includes(selectItem._id)) {
                    selectItem.selected = true
                    return false;
                };
            })

        }
        if (this.multiple && this.combineControl?.value?.length) {
            _.forEach(this.combineSelectList, (selectItem) => {
                if (selectItem.count !== 0 && this.combineControl.value.includes(selectItem._id)) {
                    selectItem.selected = true
                };
            })
        } else if (this.combineControl?.value) {
            _.forEach(this.combineSelectList, (selectItem) => {
                if (selectItem.count !== 0 && this.combineControl.value.includes(selectItem._id)) {
                    selectItem.selected = true
                    return false;
                };
            })

        }
        this.selectedLabel = this.selected.join(', ')

    }
    onChange(e) {
        //if (this.multiple) return;
        this.selectChange.emit(e);
    }

    toggleSelectValue(value, item, control) {
        if (this.multiple && !control.value?.length) control.setValue([]);
        item.selected = !item.selected;

        if (this.multiple) {
            let items = control.value || [];
            if (item.selected) {
                items.push(value);
                control.setValue(items);
            } else {
                _.remove(items, (val, index) => {
                    if (val == value) {
                        return true;
                    }
                });
                control.setValue(items);
            }
            
        }
        else {
            this.control.value ? this.control.reset() : this.control.setValue(value);
            this.isOpen = false;
            
        }
        this.selectChange.emit(value);

    }

    isOpen = false;

    menuClickOutside(event) {
        if (event.srcElement == this.btn?.nativeElement || event.srcElement == this.btnIcon?._elementRef?.nativeElement || event.srcElement == this.btnLabel?.nativeElement) {
            this.isOpen = false;
            event.preventDefault();
            event.stopPropagation();
        } else {
            let found = false;
            _.forEach(this.btnLabel?.nativeElement.children, child => {
                if (child == event.srcElement) {
                    found = true;
                    return false;
                }
            })
            this.isOpen = false;
            if (found) {
                event.preventDefault();
                event.stopPropagation();

            }

        }
    }

    toggleTrigger(evt) {
        this.isOpen = !this.isOpen;
        evt.preventDefault();
        evt.stopPropagation();
    }


}
